module.exports = __webpack_public_path__ + "img/hampton-tuscalooosa-univ-logo.f8181224.jpg";